var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "parent", staticStyle: { margin: "10px" } }, [
    _c("table", [
      _vm.column_names.length == 0 ? _c("thead", [_vm._m(0)]) : _vm._e(),
      _vm._v(" "),
      _vm.column_names.length > 0
        ? _c(
            "tbody",
            [
              _vm._l(_vm.height, function(h) {
                return _c(
                  "tr",
                  _vm._l(_vm.width, function(w) {
                    return _c("td", [
                      w - 1 + (h - 1) * _vm.width == _vm.column_names.length - 1
                        ? _c("div", { attrs: { colspan: "4" } })
                        : _c("div", [
                            _c("p", { staticClass: "colname" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.column_names[w - 1 + (h - 1) * _vm.width]
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "coldata" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.column_data[0][
                                    w - 1 + (h - 1) * _vm.width
                                  ]
                                )
                              )
                            ])
                          ])
                    ])
                  }),
                  0
                )
              }),
              _vm._v(" "),
              _c("tr", [
                _c("td", { attrs: { colspan: "4" } }, [
                  _c("p", { staticClass: "colname" }, [
                    _vm._v(
                      _vm._s(_vm.column_names[_vm.column_names.length - 1])
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "coldata" }, [
                    _vm._v(
                      _vm._s(_vm.column_data[0][_vm.column_data[0].length - 1])
                    )
                  ])
                ])
              ])
            ],
            2
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [_c("th", [_vm._v("[empty table]")])])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d0334a06", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0334a06","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/layout_3.vue
// module id = 758
// module chunks = 0